<template>
  <div style="display: flex; flex-direction: column;">
      <div style="width: 100%; display: flex; flex-direction: row;">
          <el-date-picker
              v-model="$store.state.inventoryMaster.statement.date_range"
              type="daterange"
              align="right"
              size="small"
              unlink-panels
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              value-format="yyyy-MM-dd"
              format="MMM dd yyyy"
              style="width: 450px;">
          </el-date-picker> 
          <el-select 
                  size="small"
                  v-model="$store.state.inventoryMaster.statement.store_id" 
                  filterable 
                  style="width: 250px; text-align: left; margin-left: 20px;">
                  <el-option
                      :label="'All Stores'"
                      :value="0">
                      <span style="float: left" v-html="'All Stores'"></span>
                  </el-option>
                  <el-option
                      v-for="(data, index) in $store.getters.getAccessibleStoreList"
                      :key="index"
                      :label="data.store_name"
                      :value="data.id">
                      <span style="float: left" v-html="data.store_name"></span>
                  </el-option>
              </el-select>
          <el-button @click="loadStatement" type="primary" size="small" style="margin-left: 20px;" icon="el-icon-search">Search</el-button>
        
      </div>
      <el-table
            :summary-method="getSummaries"
            :show-summary="true"
            :data="getStatementList"
            style="width: 100%; margin-top: 20px;">
          
          <el-table-column 
            label="Date">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                      {{scope.row.transaction_date_changed}}
                  </span>
              </template>
          </el-table-column>
          
          <el-table-column 
            label="Transaction">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                    {{
                        scope.row.purchase_bill_id>0 ? 'Purchase' 
                            : scope.row.intra_branch_transfer_id>0 ? 'Intra-Branch' 
                                : scope.row.sourcing_id>0 ? 'Sourced Out' 
                                    : scope.row.sales_id>0 ? 'Sales' 
                                        : scope.row.stock_check_id>0 ? 'Stock Check' 
                                            : scope.row.production_issue_id>0 ? 'Production Item Issue' 
                                                : scope.row.lost_id>0 ? 'Lost/Damaged' : ''
                    }}
                  </span>
              </template>
          </el-table-column>

          <el-table-column 
            label="Location">
            <template slot-scope="scope" v-if="scope.row.locality_name !== undefined">
                  <span class="rowFontSize">
                    {{
                        scope.row.locality_name
                    }}
                  </span>
              </template>
          </el-table-column>

          <el-table-column 
            label="Description">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                      {{
                          scope.row.purchase_bill_id>0 ? scope.row.bill_number 
                            : scope.row.intra_branch_transfer_id>0 ? scope.row.from_locality + ' to '+ scope.row.to_locality+' ('+scope.row.transfer_number+')'
                                : scope.row.sourcing_id>0 ? scope.row.full_name 
                                    : scope.row.sales_id>0 ? (scope.row.external_number !== null && scope.row.external_number.length>0) ? scope.row.external_number : scope.row.sale_number_prefix+''+scope.row.sale_number
                                        : scope.row.stock_check_id>0 ? '' 
                                            : scope.row.production_issue_id>0 ? scope.row.item_issue_external_number.length>0 
                                                ? scope.row.item_issue_external_number 
                                                    : scope.row.item_issue_sale_number_prefix+''+item_issue_scope.row.sale_number 
                                                        : scope.row.opening_stock ? 'Opening' 
                                                            : scope.row.closing_stock ? 'Closing' : ''
                      }}
                  </span>
              </template>
          </el-table-column>
          
          <el-table-column 
            label="Opening" align="center">
            <template slot-scope="scope">
                  <span class="rowFontSize" v-if="scope.row.opening_stock">
                      {{scope.row.stock+' '+getUOM}}
                  </span>
              </template>
          </el-table-column>

          <el-table-column 
            label="Debit" align="center">
            <template slot-scope="scope">
                  <span class="rowFontSize" style="color: red">
                      {{scope.row.debit_qty>0 ? scope.row.debit_qty+' '+getUOM : ''}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column 
            label="Credit" align="center">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                      <b>{{scope.row.credit_qty>0 ? scope.row.credit_qty+' '+getUOM : ''}}</b>
                  </span>
              </template>
          </el-table-column>
          
          <el-table-column 
            label="Closing" align="center">
            <template slot-scope="scope">
                  <span class="rowFontSize" v-if="scope.row.closing_stock">
                      {{scope.row.stock.toFixed(2)+' '+getUOM}}
                  </span>
              </template>
          </el-table-column>

        </el-table>


  </div>
</template>

<script>
export default {
    data() {
        return {
            page_number: 1,
        }
    },
    computed: {
        getStatementList() {
            return this.$store.state.inventoryMaster.statement.list
        },
        getPagenumber() {
            return (this.page_number*this.$store.getters.getDefaultPageLimit)-this.$store.getters.getDefaultPageLimit
        },
        getUOMID() {
            return this.$store.state.inventoryMaster.props.unit_of_measurement_id
        },
        getUOM() {
            let uomList = this.$store.getters.getUOMMasterList
            
            let index = uomList.findIndex(t => t.id === this.getUOMID)
            if(index>=0) {
                return uomList[index].unit_name
            }

            return ''
        }
    },
    methods: {
        getSummaries(param) {
            const { columns } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 1) {
                    sums[index] = '';
                    return;
                } else if (index === 2) {
                    sums[index] = '';
                    return;
                } else if (index === 3) {
                    sums[index] = '';
                    return;
                } else if (index === 4) {
                    let total = this.getStatementList.reduce((count, element1) => {return ( !isNaN(parseFloat(element1.stock)) && element1.opening_stock ? count + parseFloat(element1.stock) : count + 0);}, 0);
                    sums[index] = total.toFixed(2)+' '+this.getUOM
                    return;
                } else if (index === 5) {
                    let total = this.getStatementList.reduce((count, element1) => {return ( !isNaN(parseFloat(element1.debit_qty)) ? count + parseFloat(element1.debit_qty) : count + 0);}, 0);
                    sums[index] = total.toFixed(2)+' '+this.getUOM
                    return;
                } else if (index === 6) {
                    let total = this.getStatementList.reduce((count, element1) => {return !isNaN(parseFloat(element1.credit_qty)) ? count + parseFloat(element1.credit_qty) : count + 0;}, 0);
                    sums[index] = total.toFixed(2)+' '+this.getUOM
                    return;
                } else if (index === 7) {
                    let total = this.getStatementList.reduce((count, element1) => {return !isNaN(parseFloat(element1.stock)) && element1.closing_stock ? count + parseFloat(element1.stock) : count + 0;}, 0);
                    sums[index] = total.toFixed(2)+' '+this.getUOM
                    return
                }
            })
            return sums;
        },
        loadStatement() {
            this.page_number = 1;
            this.$store.dispatch('loadInventoryStatement', 
                {date_range: this.$store.state.inventoryMaster.statement.date_range, 
                store_id: this.$store.state.inventoryMaster.statement.store_id,
                item_code: this.$store.state.inventoryMaster.props.id})
        }
    },
    mounted() {
        this.$store.state.inventoryMaster.statement.list = []
        if(this.$store.state.inventoryMaster.statement.date_range[0].length>0) {
            this.loadStatement()
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/Statement.vue